import React, {useEffect, useState} from 'react';
import UserSelection from './UserSelection';
import AppLoader from '../../HelperClasses/AppLoaderClasses/AppLoader';
import ListingSelection from './ListingSelection';
import {getTenantKeys} from '../../Actions/getTenantKeys';
import {ToastContainer} from 'react-toastify';
import CheckoutSteps from './CheckoutSteps';
import {fetchShippingMethods} from './Actions/FetchShippingMethods';
import {fetchPaymentMethods} from './Actions/FetchPaymentMethods';
import {checkout_submit} from './Actions/onCheckout';

const CreateOrder = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selected_user, setSelectedUser] = useState(null);
  const [current_step, setCurrentStep] = useState(1);
  const [fullCartInfo, setFullCartInfo] = useState(null);
  const [tenantKeys, setTenantKeys] = useState(null);
  const [shippingMethods, setShippingMethods] = useState(null);
  const [selectedShippingMethod, setSelectedShippingMethod] = useState(null);
  const [selectedShipmentMethod, setSelectedShipmentMethod] = useState(null);
  const [selectedExternalShipmentMethod, setSelectedExternalShipmentMethod] =
    useState(null);
  const [selectedShipmentAddress, setSelectedShipmentAddress] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  useEffect(() => {
    getTenantKeys().then(res => {
      setTenantKeys(res.tenant_keys);
    });
  }, []);

  useEffect(() => {
    if (selected_user) {
      fetchShippingMethods({
        setShippingMethods,
        setSelectedShippingMethod,
        setIsLoading,
        selectedUser: selected_user,
        pk_key: tenantKeys?.[1]?.key,
      });
      fetchPaymentMethods({
        setPaymentMethods,
        setSelectedPaymentMethod,
        setIsLoading,
        selectedUser: selected_user,
        pk_key: tenantKeys?.[1]?.key,
      });
    }
  }, [selected_user]);

  // checkout

  const clickCheckOut = () => {
    const checkoutType = fullCartInfo?.cart_details[0]?.listing?.order_type;
    console.log('checkoutType', checkoutType);
    checkout_submit({
      cart_details: fullCartInfo?.cart_details,
      cart: fullCartInfo?.cart,
      specialCheckoutTypes: ['appointments', 'events', 'donation'],
      checkoutType: checkoutType ? checkoutType : 'listings',
      selectedScheduleTimeIndex: null,
      setShowError: null,
      commissions: null,
      setError_message: null,
      auth_key: null,
      selectShippingAddress: null,
      shippingMethod: selectedShippingMethod,
      selectStorageHubAddress: null,
      scheduleArray: null,
      selectedDateIndex: null,
      cart_commission: null,
      paymentMethod: selectedPaymentMethod,

      selected_shipment_method: null,
      selectedExternalShipmentMethod: null,
      demand_commission: null,
      isDonateAnonymously: null,
      item_attributes: null,
      cart_attributes: null,
      domain_details: null,
      is_push_checkout_success_page: false,
      setIsLoading,
      selectedUser: selected_user,
      pk_key: tenantKeys?.[1]?.key,
      setFullCartInfo,
    });
  };

  return (
    <div className="   w-full  flex items-start justify-between  ">
      <div className="max-h-[92dvh]   h-full   pb-8 max-w-[60%] w-full flex flex-col gap-4">
        <UserSelection
          current_step={current_step}
          setCurrentStep={setCurrentStep}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setSelectedUser={setSelectedUser}
          selectedUser={selected_user}
          fullCartInfo={fullCartInfo}
          setFullCartInfo={setFullCartInfo}
        />

        <ListingSelection
          current_step={current_step}
          setCurrentStep={setCurrentStep}
          selectedUser={selected_user}
          fullCartInfo={fullCartInfo}
          setFullCartInfo={setFullCartInfo}
          setIsLoading={setIsLoading}
          pk_key={tenantKeys?.[1]?.key}
        />
      </div>
      <div className="flex flex-row justify-between max-w-[40%] w-full max-h-[92dvh]   h-full   overflow-y-auto">
        <CheckoutSteps
          fullCartInfo={fullCartInfo}
          setFullCartInfo={setFullCartInfo}
          setCurrentStep={setCurrentStep}
          pk_key={tenantKeys?.[1]?.key}
          setIsLoading={setIsLoading}
          selectedUser={selected_user}
          shippingMethods={shippingMethods}
          setShippingMethods={setShippingMethods}
          selectedShippingMethod={selectedShippingMethod}
          setSelectedShippingMethod={setSelectedShippingMethod}
          selectedShipmentMethod={selectedShipmentMethod}
          setSelectedShipmentMethod={setSelectedShipmentMethod}
          selectedExternalShipmentMethod={selectedExternalShipmentMethod}
          setSelectedExternalShipmentMethod={setSelectedExternalShipmentMethod}
          selectedShipmentAddress={selectedShipmentAddress}
          setSelectedShipmentAddress={setSelectedShipmentAddress}
          paymentMethods={paymentMethods}
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          clickCheckOut={clickCheckOut}
          isLoading={isLoading}
        />
      </div>

      <AppLoader enable={isLoading ? false : true} />
      <ToastContainer />
    </div>
  );
};

export default CreateOrder;
